import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { isRequesterUser } from 'app/core/auth/requester-user';
import { CompanyService } from 'app/services/company.service';
import { ApiService } from 'app/shared/apis/api.service';
import { map, take } from 'rxjs';

/** Redireciona solicitantes de /services para o portal dedicado. */
export const RequesterServicesRedirectGuard: CanActivateFn = (route) => {
    const router = inject(Router);
    const companyService = inject(CompanyService);

    return ApiService.userCurrent.pipe(
        take(1),
        map((user) => {
            if (!isRequesterUser(user, companyService.getCurrentCompany())) {
                return true;
            }

            const queryParams = route.queryParams;
            const hasQuery = Object.keys(queryParams).length > 0;
            return router.createUrlTree(['/requester/services'], hasQuery ? { queryParams } : undefined);
        }),
    );
};
